import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import VersionBadge from './VersionBadge';

const baseMenuItems = [
  { path: '/admin/dashboard', label: 'Dashboard', icon: '📊' },
  { path: '/admin/informes', label: 'Informes', icon: '📈' },
  { path: '/admin/empleados', label: 'Empleados', icon: '👥' },
  { path: '/admin/notificaciones', label: 'Notificaciones', icon: '✉️' },
  { path: '/admin/plantillas', label: 'Plantillas', icon: '📋' },
  { path: '/admin/configuracion', label: 'Configuración', icon: '⚙️' }
];

const superadminItems = [
  { path: '/admin/sistema', label: 'Sistema', icon: '🖥️' }
];

function AdminLayout({ children, title }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuOpen, setMenuOpen] = useState(false);
  const [userName, setUserName] = useState('');
  const [userRole, setUserRole] = useState('');
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      navigate('/admin');
      return;
    }
    setUserName(localStorage.getItem('adminName') || 'Administrador');
    setUserRole(localStorage.getItem('adminRole') || 'admin');
    setUserEmail(localStorage.getItem('adminEmail') || '');

    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminName');
    localStorage.removeItem('adminRole');
    localStorage.removeItem('adminEmail');
    navigate('/admin');
  };

  const handleNavClick = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  const menuItems = userRole === 'superadmin'
    ? [...baseMenuItems, ...superadminItems]
    : baseMenuItems;

  const sidebarContent = (
    <>
      <div className="sidebar__logo">
        <div className="sidebar__logo-text">EMILIO MORO</div>
        <div className="sidebar__logo-subtext">Panel de Administración</div>
      </div>
      <nav className="sidebar__nav">
        <div className="sidebar__nav-section">Principal</div>
        {menuItems.slice(0, 4).map((item) => (
          <div
            key={item.path}
            className={`sidebar__nav-item ${location.pathname === item.path ? 'sidebar__nav-item--active' : ''}`}
            onClick={() => handleNavClick(item.path)}
          >
            <span>{item.icon}</span>
            <span>{item.label}</span>
          </div>
        ))}

        <div className="sidebar__nav-section">Configuración</div>
        {menuItems.slice(4).map((item) => (
          <div
            key={item.path}
            className={`sidebar__nav-item ${location.pathname === item.path ? 'sidebar__nav-item--active' : ''}`}
            onClick={() => handleNavClick(item.path)}
          >
            <span>{item.icon}</span>
            <span>{item.label}</span>
            {item.path === '/admin/sistema' && (
              <span className="badge badge--sm badge-superadmin">Super</span>
            )}
          </div>
        ))}
      </nav>
      <div className="sidebar__user-info">
        <div className="sidebar__user-name">
          {userName}
          <span className={`badge badge--sm ${userRole === 'superadmin' ? 'badge-superadmin' : 'badge-admin'}`}>
            {userRole === 'superadmin' ? 'Super Admin' : 'Admin'}
          </span>
        </div>
        <div className="sidebar__user-role">{userEmail}</div>
        <button className="sidebar__logout-btn" onClick={handleLogout}>
          Cerrar sesión
        </button>
      </div>
    </>
  );

  return (
    <div className="admin-layout">
      {isMobile && (
        <>
          <div className={`topbar topbar--visible ${menuOpen ? 'topbar--hidden' : ''}`}>
            <button className="topbar__menu-btn" onClick={() => setMenuOpen(true)}>
              ☰
            </button>
            <span style={{ fontWeight: '600' }}>{title}</span>
            <div style={{ width: '24px' }}></div>
          </div>
          <div
            className={`overlay ${menuOpen ? 'overlay--visible' : ''}`}
            onClick={() => setMenuOpen(false)}
          />
          <aside className={`sidebar--mobile ${menuOpen ? 'sidebar--mobile-open' : ''}`}>
            {sidebarContent}
          </aside>
        </>
      )}

      {!isMobile && <aside className="sidebar">{sidebarContent}</aside>}

      <VersionBadge />

      <main
        className={`admin-content ${isMobile ? 'admin-content--mobile' : ''}`}
        style={isMobile ? { paddingTop: '80px' } : undefined}
      >
        {!isMobile && (
          <h1 className="admin-content__title">
            {title}
          </h1>
        )}
        {children}
      </main>
    </div>
  );
}

export default AdminLayout;
